import { Box, Tab, Tabs } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppThemeContext } from '../../../shared/contexts';
import { whatsAppService } from '../../../shared/services/api/whatsapp';
import { IPropsBusinessPage } from '../Business';
import { WhatsAppBotConfig } from './WhatsAppBotConfig';
import { WhatsAppBotConnect } from './WhatsAppBotConnect';
import { WhatsAppBotHistory } from './WhatsAppBotHistory';
import { WhatsAppBotTools } from './WhatsAppBotTools';
import { WhatsAppMessages } from './WhatsAppMessages';

enum WhatsAppSubTab {
  Messages = 0,
  IA = 1,
}

enum IASubTab {
  Config = 0,
  Tools = 1,
  History = 2,
  Connect = 3,
}

export const BusinessWhatsApp: React.FC<IPropsBusinessPage> = (props) => {
  const { business } = props;
  const { lgDown } = useAppThemeContext();
  const location = useLocation();

  const [subTab, setSubTab] = useState<WhatsAppSubTab>(
    (location.state as Record<string, unknown>)?.subPage === 1 ? WhatsAppSubTab.IA : WhatsAppSubTab.Messages
  );
  const [iaSubTab, setIaSubTab] = useState(IASubTab.Connect);

  const { data: status } = useQuery({
    queryKey: ['whatsapp-status', business.id],
    queryFn: () => whatsAppService.getConnectionStatus(business.id),
    refetchInterval: (data) => (data?.connected ? false : 5000),
  });

  const isConnected = status?.connected ?? false;

  // Quando conecta, vai pra Config por padrão
  useEffect(() => {
    if (isConnected) {
      setIaSubTab((prev) => (prev === IASubTab.Connect ? IASubTab.Config : prev));
    }
  }, [isConnected]);

  return (
    <Box>
      {/* Tabs principais: Mensagens | IA */}
      <Tabs
        value={subTab}
        onChange={(_, v) => setSubTab(v)}
        variant='scrollable'
        sx={{ mb: 2 }}
      >
        <Tab label='Mensagens' iconPosition={lgDown ? 'top' : 'start'} />
        <Tab label='IA' iconPosition={lgDown ? 'top' : 'start'} />
      </Tabs>

      {/* ── Aba Mensagens (sempre visível) ── */}
      {subTab === WhatsAppSubTab.Messages && <WhatsAppMessages {...props} />}

      {/* ── Aba IA ── */}
      {subTab === WhatsAppSubTab.IA && (
        <>
          {!isConnected ? (
            <WhatsAppBotConnect {...props} />
          ) : (
            <>
              <Tabs
                value={iaSubTab}
                onChange={(_, v) => setIaSubTab(v)}
                variant='scrollable'
                sx={{ mb: 2 }}
              >
                <Tab label='Configuração' iconPosition={lgDown ? 'top' : 'start'} />
                <Tab label='Ferramentas' iconPosition={lgDown ? 'top' : 'start'} />
                <Tab label='Histórico' iconPosition={lgDown ? 'top' : 'start'} />
                <Tab label='Conexão' iconPosition={lgDown ? 'top' : 'start'} />
              </Tabs>

              {iaSubTab === IASubTab.Config && <WhatsAppBotConfig {...props} />}
              {iaSubTab === IASubTab.Tools && <WhatsAppBotTools {...props} />}
              {iaSubTab === IASubTab.History && <WhatsAppBotHistory {...props} />}
              {iaSubTab === IASubTab.Connect && <WhatsAppBotConnect {...props} />}
            </>
          )}
        </>
      )}
    </Box>
  );
};
